export default "__VITE_PUBLIC_ASSET__a2193757__"